import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routing } from './routes';

@NgModule({
    imports: [
        RouterModule.forRoot(Routing, { scrollPositionRestoration: 'top' }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
